export function getRandomElements<T>(arr: Array<T>, n: number): Array<T> {
  if (arr.length < n) {
    throw new Error(
      "The value of n should be less than or equal to the array length (m)."
    );
  }

  // Fisher-Yates shuffle algorithm
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr.slice(0, n);
}
